export const smsFormLoaded = phone => {
  const properties = {
    phone,
  };
  analytics.track('SMS Subscription Form Loaded', properties);
};

export const smsSubscriptionCreated = () => {
  analytics.track('SMS Subscription Created', {});
};



// WEBPACK FOOTER //
// ./app/javascript/apps/sms_subscriptions/tracking.js